import { createReducer, on } from "@ngrx/store";
import { copyLanguage, copyLanguageFailed, copyLanguageSuccess } from "./copy-language.actions";

export interface CopyLanguageState {
    data: any | null;
    isLoading: boolean;
    error: string | null;
}

const initialState: CopyLanguageState = {
    data: null,
    isLoading: false,
    error: null
}

export const copyLanguageReducer = createReducer(
    initialState,
    on(copyLanguage, (state): CopyLanguageState => ({
        ...state,
        isLoading: true,
        error: null
    })),
    on(copyLanguageSuccess, (state, { response }): CopyLanguageState => ({
        ...state,
        isLoading: false,
        data: response,
        error: null
    })),
    on(copyLanguageFailed, (state, { error }): CopyLanguageState => ({
        ...state,
        isLoading: false,
        data: null,
        error
    }))
)
